<template>
  <div class="formDetailReportComponent">
    <div v-if="loading" class="text-center">
      <v-progress-circular
        class="mt-auto"
        :size="70"
        :width="7"
        color="primary"
        indeterminate
      ></v-progress-circular>
    </div>
    <div v-else class="col-10">
      <div class="ContainerRecordatorio">
        <div class="ContainerRecorda">
          <v-icon color="#f88623" x-large>mdi-alert-circle</v-icon>
          <p>
            <span>
              {{ $t('report.label.assignment.text') }}
            </span>
          </p>
        </div>
        <v-form ref="formulario" lazy-validation class="mt-5 col-10">
          <div class="formReport">
            <v-select :label="'*'+$t('starAssignment.label.star.title')" :placeholder="$t('starAssignment.label.star.text')" 
              required :rules="starRules" color="secondary" :items="typeStartList" item-text="nameStar" 
              item-value="starId" v-model="formData.assignTypeStar"></v-select>

            <v-menu
              v-model="menu1"
              :close-on-content-click="false"
              transition="scale-transition"
              color="secondary"
              offset-y
              max-width="290px"
              min-width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="formattedStartDate"
                  :label="'*' + $t('novelties.label.startDate')"
                  color="secondary"
                  :rules="startDateRules"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="localStartDate"
                color="primary"
                @change="handleStartDateChange"
              ></v-date-picker>
            </v-menu>
  
            <v-menu
              v-model="menu2"
              :close-on-content-click="false"
              transition="scale-transition"
              color="secondary"
              offset-y
              max-width="290px"
              min-width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="formattedEndDate"
                  :label="'*' + $t('novelties.label.endDate')"
                  color="secondary"
                  :rules="endDateRules"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="localEndDate"
                color="primary"
                @change="handleEndDateChange"
                ></v-date-picker>
            </v-menu>

            <v-select :label="'*'+$t('starAssignment.label.assign.title')" :placeholder="$t('starAssignment.label.assign.text')" 
            :items="typeAssign" item-text="assignTypeName" item-value="assignTypeId" v-model="formData.assignTypeName" 
            required :rules="assygnTypeRules" color="secondary"></v-select>
          </div>
        </v-form>
        <searchIndividual :data="this.formData"/>
      </div>
    </div>
  </div>
</template>

<script>
import searchIndividual from "@/views/reports/pages/detail_report/components/form_search_individual_component.vue";
  
import {
  STARASSIGNMENT_M,
  GET_LIST_TYPE_STAR_LIST,
  GET_STARASSIGNMENT_LIST,
  ACTION_GET_TYPE_STAR_LIST,
  ACTION_GET_STAR_ASSIGNMENT_REPORT_LIST
} from "@/views/star_assignment/store/types/types.js";

import Swal from "sweetalert2";
import { mapActions, mapGetters } from "vuex";
import i18n from '@/plugins/i18n';

export default {
  name: "detailReportComponent",
  props: {
    report: {
      required: true,
    },
  },
  components: {
    searchIndividual,
  },
  data() {
    return {
      formData: {
        assignTypeStar: null,
        startDate: null,
        endDate: null,
        assignTypeName: null
      },
      menu1: false, // Para el date picker de fecha inicio
      menu2: false, // Para el date picker de fecha fin
      localStartDate: null,
      localEndDate: null,
      formattedStartDate: '',
      formattedEndDate: '',
      loading: false,
      starRules: [
        v => !!v || this.$t('starAssignment.label.star.required')
      ],
      startDateRules: [
        v => !!v || this.$t('report.label.startDate.required'),
      ],
      endDateRules: [
        v => !!v || this.$t('report.label.endDate.required'),
      ],
      assygnTypeRules: [
        v => !!v || this.$t('starAssignment.label.typeStar.required')
      ]
    };
  },
  async mounted() {
    await this.getActiontypeStartList();
    await this.getActionTypeAssign();
  },
  methods: {
    handleStartDateChange(date) {
      const selectedDate = new Date(`${date}T00:00:00`);
      if (isNaN(selectedDate)) {
          console.error("Invalid date object:", date);
          return;
      }
      
      this.localStartDate = date;
      const modifiedDate = new Date(selectedDate);
      this.formData.startDate = date;
      this.formattedStartDate = date;
      this.validateStartDate(modifiedDate);
      this.menu1 = false;
    },

    validateStartDate(modifiedDate) {
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      const selectedDate = new Date(modifiedDate);
      if (this.formData.assignTypeStar == "1") {
        if (selectedDate > today) {
          Swal.fire({
          icon: "error",
          title: i18n.t('label.date.invalid'),
          text: i18n.t('label.startDate.invalid.text4'),
          });
          this.localStartDate = null;
          this.formattedStartDate = "";
          this.formData.startDate = null;
          return;
        }
      }

      if(this.formData.endDate != null){
        if (this.formData.startDate > this.formData.endDate) {
          Swal.fire({
          icon: "error",
          title: i18n.t('label.date.invalid'),
          text: i18n.t('label.startDate.invalid.text3'),
          });
          this.localStartDate = null;
          this.formattedStartDate = "";
          this.formData.startDate = null;
          return;
        }
      }
    },

    handleEndDateChange(date) {
      const selectedDate = new Date(`${date}T00:00:00`);
      if (isNaN(selectedDate)) {
          console.error("Invalid date object:", date);
          return;
      }
      this.localEndDate = date;
      const modifiedDate = new Date(selectedDate);
      this.formData.endDate = date;
      this.formattedEndDate = date;
      this.validateEndDate(this.localEndDate, modifiedDate);
      this.menu2 = false;
    },

    validateEndDate(localEndDate, modifiedDate) {
      if (localEndDate < this.localStartDate) {
        Swal.fire({
        icon: "error",
        title: i18n.t('label.date.invalid'),
        text: i18n.t('label.endDate.invalid.text1'),
        });
        this.localEndDate = null;
        this.formattedEndDate = "";
        this.formData.endDate = null;
        return;
      }
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      const selectedDate = new Date(modifiedDate);

      if (this.formData.assignTypeStar == "1") {
        if (selectedDate > today) {
          Swal.fire({
          icon: "error",
          title: i18n.t('label.date.invalid'),
          text: i18n.t('label.endDate.invalid.text3')
          });
          this.localEndDate = null;
          this.formattedEndDate = "";
          this.formData.endDate = null;
          return;
        }
      }
    },

    ...mapActions({
      getActiontypeStartList: `${STARASSIGNMENT_M}${ACTION_GET_TYPE_STAR_LIST}`,
      getActionTypeAssign: `${STARASSIGNMENT_M}${ACTION_GET_STAR_ASSIGNMENT_REPORT_LIST}`
    }),
  },
  computed: {
    ...mapGetters({
      typeStartList: [`${STARASSIGNMENT_M}${GET_LIST_TYPE_STAR_LIST}`],
      typeAssign: [`${STARASSIGNMENT_M}${GET_STARASSIGNMENT_LIST}`],
    }),
  }
};
</script>

<style lang="css" scoped>
.formDetailReportComponent {
  display: flex;
  justify-content: center;
}

.ContainerRecorda {
  background-color: #ff770048;
  width: 92%;
  height: 75px;
  border-radius: 12px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-top: 20px;
  gap: 8px;
  padding-left: 15px;
}

.ContainerRecordatorio {
  display: flex;
  flex-direction: column;
  gap: 20px;
  align-items: center;
  margin: 20px 0px;
}

.ContainerRecordatorio p {
  margin-bottom: 0 !important;
}

p span {
  color: #6e17a5;
  font-weight: bold;
  font-size: 15px;
}

.formReport {
  display: flex;
  gap: 60px;
  flex-direction: row;
  justify-content: center;
}

/*Resposive*/

@media screen and (max-width: 768px) {
  .formReport {
    display: flex;
    gap: 40px;
    flex-direction: column;
    justify-content: center;
  }

  p span {
    font-size: 12px;
  }
}

@media screen and (max-width: 425px) {
  .formReport {
    display: flex;
    gap: 50px;
    flex-direction: column;
    justify-content: center;
  }
}
</style>
